import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@components/ui/SegmentedControl/SegmentedControl';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { setLayer } from '@store/slices/monitor.slice';
import { selectMonitorLayer } from '@store/selectors/monitor.selectors';
import { FullscreenToggle } from '../fullscreen/FullscreenToggle';
import type { MonitorLayer } from '../layers/layers';
import { ReplayToggle } from '../replay/ReplayToggle';
import type { IReplayController } from '../replay/useReplayController';

const LAYERS: readonly MonitorLayer[] = ['workforce', 'activities', 'issues'];

interface IBuildingCardControlsProps {
  replay?: IReplayController;
}

/** Replay, the layer switch and fullscreen: in the building card's header, or fullscreen's top bar. */
export function BuildingCardControls({ replay }: IBuildingCardControlsProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const layer = useAppSelector(selectMonitorLayer);
  return (
    <>
      {replay && <ReplayToggle open={replay.open} onToggle={replay.toggle} />}
      <SegmentedControl
        value={layer}
        onChange={(next) => dispatch(setLayer(next))}
        ariaLabel={t('monitor.layers.switchLabel')}
        options={LAYERS.map((id) => ({ id, label: t(`monitor.layers.${id}`) }))}
      />
      <FullscreenToggle />
    </>
  );
}
